import moment from "moment";
import unitConvertor from "./components/unitConversion/unitConvertor";

export const generateNumber = (format = "", uid, props) => {
  let isentryDate = props?.entryDate ? new Date(props?.entryDate) : new Date();
  if (format?.includes("DDMMYYYY")) {
    format = format?.replace("DDMMYYYY", moment(isentryDate).format("DDMMYYYY"));
  }
  if (format?.includes("MM/YYYY")) {
    format = format?.replace("MM/YYYY", moment(isentryDate).format("MM/YYYY"));
  }
  if (format?.includes("DDMMYY")) {
    format = format?.replace("DDMMYY", moment(isentryDate).format("DDMMYY"));
  }
  if (format?.includes("YYYYMMDD")) {
    format = format?.replace("YYYYMMDD", moment(isentryDate).format("YYYYMMDD"));
  }
  if (format?.includes("YYYY/MM/DD")) {
    format = format?.replace(
      "YYYY/MM/DD",
      moment(isentryDate).format("YYYY/MM/DD")
    );
  }
  if (format?.includes("YYMMDD")) {
    format = format?.replace("YYMMDD", moment(isentryDate).format("YYMMDD"));
  } else if (format?.includes("MMYYYY")) {
    format = format?.replace("MMYYYY", moment(isentryDate).format("MMYYYY"));
  } else if (format?.includes("DD/MM/YYYY")) {
    format = format?.replace(
      "DD/MM/YYYY",
      moment(isentryDate).format("DD/MM/YYYY")
    );
  } else if (format?.includes("DD/MM/YY")) {
    format = format?.replace("DD/MM/YY", moment(isentryDate).format("DD/MM/YY"));
  } else if (format?.includes("YYYY-DD-MM")) {
    format = format?.replace(
      "YYYY-DD-MM",
      moment(isentryDate).format("YYYY-DD-MM")
    );
  } else if (format?.includes("YYMM")) {
    format = format?.replace("YYMM", moment(isentryDate).format("YYMM"));
  } else if (format?.includes("YYDD")) {
    format = format?.replace("YYDD", moment(isentryDate).format("YYDD"));
  } else if (format?.includes("DD-MM-YY")) {
    format = format?.replace("DD-MM-YY", moment(isentryDate).format("DD-MM-YY"));
  } else if (format?.includes("MM-YY")) {
    format = format?.replace("MM-YY", moment(isentryDate).format("MM-YY"));
  } else if (format?.includes("YYYY/MM")) {
    format = format?.replace("YYYY/MM", moment(isentryDate).format("YYYY/MM"));
  } else if (format?.includes("YYYY")) {
    format = format?.replace("YYYY", moment(isentryDate).format("YYYY"));
  } else if (format?.includes("DDYY")) {
    format = format?.replace("DDYY", moment(isentryDate).format("DDYY"));
  } else if (format?.includes("DDMM")) {
    format = format?.replace("DDMM", moment(isentryDate).format("DDMM"));
  } else if (format?.includes("MMYY")) {
    format = format?.replace("MMYY", moment(isentryDate).format("MMYY"));
  } else if (format?.includes("MM/YY")) {
    format = format?.replace("MM/YY", moment(isentryDate).format("MM/YY"));
  } else if (format?.includes("M/YY")) {
    format = format?.replace("M/YY", moment(isentryDate).format("M/YY"));
  } else if (format?.includes("DD")) {
    format = format?.replace("DD", moment(isentryDate).format("DD"));
  }

  let no = format?.indexOf("{no}");
  let digits = 0;
  if (no !== -1 && /[\d]/.test(format?.slice(no + 4))) {
    digits = Number(
      format
        .slice(no + 4)
        ?.split("]")[0]
        ?.split("[")?.[1]
    );
    format = format?.replace(`[${digits}]`, "");
  }
  format = format?.replace(
    "{no}",
    digits ? `${uid}`.padStart(digits, "0") + "F" : uid
  );
  no = format?.indexOf("{no}");
  format = format?.replace("{branch}", props?.branch);
  format = format?.replace("{discipline}", props?.discipline);
  format = format?.replace(
    "{calibrationProcedureNo}",
    props?.calibrationProcedureNo
  );
  return format;
};

export const getFormattedDates = (from, to) => {
  const fromDate = moment(from)
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  const toDate = moment(to).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");

  return { fromDate, toDate };
};

export function timeStringToTimestamp(timeString, format = "h:min:s:ms:μs") {
  let checks = {
    hour: false,
    minute: false,
    second: false,
    decisecond: false,
    centisecond: false,
    millisecond: false,
    microsecond: false,
  };

  if (format.includes("h")) {
    checks.hour = true;
  }
  if (format.includes("min")) {
    checks.minute = true;
  }
  if (
    format.includes(":s") ||
    format.includes("s:ms") ||
    format.includes("s:ds") ||
    format.includes("s:cs") ||
    format.includes("s:μs") ||
    format == "s"
  ) {
    checks.second = true;
  }
  if (format.includes("ds")) {
    checks.decisecond = true;
  }
  if (format.includes("cs")) {
    checks.centisecond = true;
  }
  if (format.includes("ms")) {
    checks.millisecond = true;
  }
  if (format.includes("μs")) {
    checks.microsecond = true;
  }

  let [hours, minutes, seconds, deciseconds, milliseconds, microseconds] = [
    0, 0, 0, 0, 0, 0,
  ];

  if (checks.hour) {
    hours = Number(timeString.split(":")[0]);
    timeString = timeString.split(":").slice(1).join(":");
  }
  if (checks.minute) {
    minutes = Number(timeString.split(":")[0]);
    timeString = timeString.split(":").slice(1).join(":");
  }
  if (checks.second) {
    seconds = Number(timeString.split(":")[0]);
    timeString = timeString.split(":").slice(1).join(":");
  }

  if (checks.decisecond) {
    deciseconds = Number(timeString.split(":")[0]);
    timeString = timeString.split(":").slice(1).join(":");
  }

  if (checks.centisecond) {
    milliseconds += Number(timeString.split(":")[0]) * 10;
    timeString = timeString.split(":").slice(1).join(":");
  }

  if (checks.millisecond) {
    milliseconds += Number(timeString.split(":")[0]);
    timeString = timeString.split(":").slice(1).join(":");
  }

  if (checks.microsecond) {
    microseconds = Number(timeString.split(":")[0]);
    timeString = timeString.split(":").slice(1).join(":");
  }

  let res = 0;
  if (hours > 0) {
    res += hours * 60 * 60 * 1000000;
  }
  if (minutes > 0) {
    res += minutes * 60 * 1000000;
  }
  if (seconds > 0) {
    res += seconds * 1000000;
  }
  if (deciseconds > 0) {
    res += deciseconds * 100000;
  }
  if (milliseconds > 0) {
    res += milliseconds * 1000;
  }
  if (microseconds > 0) {
    res += microseconds;
  }
  return res;
}


export function timestampToTimeString(timestamp, format = "h:min:s:ms:μs") {
timestamp = Math.round(timestamp);
  let checks = {
    hour: false,
    minute: false,
    second: false,
    decisecond: false,
    centisecond: false,
    millisecond: false,
    microsecond: false,
  };

  if (format.includes("h")) {
    checks.hour = true;
  }
  if (format.includes("min")) {
    checks.minute = true;
  }
  if (
    format.includes(":s") ||
    format.includes("s:ms") ||
    format.includes("s:ds") ||
    format.includes("s:cs") ||
    format.includes("s:μs") ||
    format == "s"
  ) {
    checks.second = true;
  }
  if (format.includes("ds")) {
    checks.decisecond = true;
  }
  if (format.includes("cs")) {
    checks.centisecond = true;
  }
  if (format.includes("ms")) {
    checks.millisecond = true;
  }
  if (format.includes("μs")) {
    checks.microsecond = true;
  }

  let timeString = [];

  let isNegative = Number(timestamp) < 0;
  timestamp = Math.abs(timestamp);

  if (checks.hour) {
    const hours = Math.floor(timestamp / (60 * 60 * 1000000));
    timeString.push(String(hours).padStart(2, "0"));
    timestamp %= 60 * 60 * 1000000;
  }
  if (checks.minute) {
    const minutes = Math.floor(timestamp / (60 * 1000000));
    timeString.push(String(minutes).padStart(2, "0"));
    timestamp %= 60 * 1000000;
  }
  if (checks.second) {
    const seconds = Math.floor(timestamp / 1000000);
    timeString.push(String(seconds).padStart(2, "0"));
    timestamp %= 1000000;
  }
  if (checks.decisecond) {
    const deciseconds = Math.round(timestamp / 100000);
    timeString.push(String(deciseconds).padStart(1, "0"));
    timestamp %= 100000;
  }
  if (checks.centisecond) {
    const centiseconds = Math.round(timestamp / 10000);
    timeString.push(String(centiseconds).padStart(2, "0"));
    timestamp %= 10000;
  }
  if (checks.millisecond) {
    const milliseconds = Math.round(timestamp / 1000);
    timeString.push(String(milliseconds).padStart(3, "0"));
    timestamp %= 1000;
  }
  if (checks.microsecond) {
    timeString.push(String(Math.round(timestamp)).padStart(3, "0"));
  }

  timeString = timeString.join(":");
  if (isNegative) {
    timeString = `-${timeString}`;
  }
  return timeString;
}


export const angleToTimestamp = (angle, format = `° ' "`) => {
  angle = String(angle);
  let checks = {
    degree: true,
    minute: true,
    second: true,
  };
  if (format == `' "`) {
    checks.degree = false;
  }
  if (format == `° '`) {
    checks.second = false;
  }
  let [degree, minute, second] = [0, 0, 0];
  if (checks.degree) {
    degree = Number(angle.split("-")[0]);
    angle = angle.split("-").slice(1).join("-");
  }
  if (checks.minute) {
    minute = Number(angle.split("-")[0]);
    angle = angle.split("-").slice(1).join("-");
  }
  if (checks.second) {
    second = Number(angle.split("-")[0]);
    angle = angle.split("-").slice(1).join("-");
  }
  if (isNaN(degree) || isNaN(minute) || isNaN(second)) {
    return 0;
  }
  if (minute > 60) {
    minute = 60;
  }
  if (second > 60) {
    second = 60;
  }
  if (degree > 360) {
    degree = 360;
  }

  // convert to arcseconds
  return degree * 3600 + minute * 60 + second;
};
export const timestampToAngle = (mas, format = `° ' "`) => {
  let isNegative = Number(mas) < 0;
  mas = Math.abs(mas);

  let checks = {
    degree: true,
    minute: true,
    second: true,
  };

  if (format == `' "`) checks.degree = false;
  if (format == `° '`) checks.second = false;

  let value = [];

  let degree = 0;
  let minute = 0;
  let second = 0;

  if (checks.degree) {
    degree = Math.floor(mas / 3600);
    mas %= 3600;
  }

  if (checks.minute) {
    minute = Math.floor(mas / 60);
    mas %= 60;
  }

  if (checks.second) {
    second = Math.round(mas);
  }

  // handle overflow
  if (second === 60) {
    second = 0;
    minute += 1;
  }

  if (minute === 60) {
    minute = 0;
    degree += 1;
  }

  if (checks.degree) value.push(String(degree));
  if (checks.minute) value.push(String(minute).padStart(2, "0"));
  if (checks.second) value.push(String(second).padStart(2, "0"));

  let result = value.join("-");

  if (isNegative) result = `-${result}`;

  return result;
};

export const formatSpecialValuesToNumber = (value, fromUnit) => {
  value = String(value);
  let currentUnit = fromUnit;
  if (
    fromUnit.includes("h") ||
    fromUnit.includes("min") ||
    fromUnit.includes("s") ||
    fromUnit.includes("ms") ||
    fromUnit.includes("μs")
  ) {
    value = timeStringToTimestamp(value, fromUnit);
    currentUnit = "μs";
  } else if (
    fromUnit.includes("°") ||
    fromUnit.includes("'") ||
    fromUnit.includes('"')
  ) {
    value = angleToTimestamp(value, fromUnit);
    currentUnit = "mas";
  }

  // convert to base units of the respective measure
  if (currentUnit == "μs") {
    value = unitConvertor(value, "μs", "s");
    currentUnit = "s";
  } else if (currentUnit == "mas") {
    value = unitConvertor(value, "mas", "°");
    currentUnit = "°";
  }

  return [value, fromUnit, currentUnit];
};

export const formatNumberToSpecialValues = (val, desiredUnit) => {
  if (
    desiredUnit.includes("h") ||
    desiredUnit.includes("min") ||
    desiredUnit.includes("s") ||
    desiredUnit.includes("ms") ||
    desiredUnit.includes("μs")
  ) {
    val = timestampToTimeString(val, desiredUnit);
  } else if (
    desiredUnit.includes("°") ||
    desiredUnit.includes("'") ||
    desiredUnit.includes('"')
  ) {
    val = timestampToAngle(val, desiredUnit);
  }
  return String(val);
};

